<script>
// 1. 初始值（兜底）
let service = 'https://bzst.zhongkevip.cn'

// 2. 封装URL获取逻辑，确保能正确读取含哈希的完整URL
const getValidUrl = () => {
  // 确保window对象已加载，且完整读取URL（包括#后的哈希）
  if (typeof window === 'undefined') return '';
  // 优先用location.href（完整URL），兼容hash路由场景
  return window.location.href || window.location.toString();
};

// 3. 延迟执行匹配（避免URL未加载完成）
const urls = getValidUrl();
// 优化匹配逻辑：只要URL包含dev- 或 dev2-，就用开发域名
if (urls.includes('dev-') || urls.includes('dev2-')) {
  service = 'https://dev-bzst.zhongkevip.cn';
}
// 额外兜底：如果URL不含zhongkevip（比如本地localhost），也用开发域名
else if (!urls.includes('zhongkevip')) {
  service = 'https://dev-bzst.zhongkevip.cn';
}

// 其他变量
var tNum = 0;
var UserData = {};

// 导出（确保其他文件引用的是最终赋值的service）
export default {
  service,
  UserData,
  tNum
};
</script>



// WEBPACK FOOTER //
// src/base/global.vue